
export enum ProRequestDetailStatusCd {
	APPROVED = 'Approved',
	CANCEL = 'Cancel',
	DECLINED = 'Declined',
	IN_PROCESS = 'InProcess',
	NEW = 'New',
	WAITING_REQUESTER_RESPONSE = 'WaitingRequesterResponse'}

